var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useConfig } from "@/contexts/cdpConfig";
import { getFeaturesEnabled } from "@/utils";
import { useCreateSavedSearch } from "@aviv-saved-search/shared/CreateSavedSearch";
import { mapQuerystringToSearchModel } from "@aviv-search/transformers";
import { useEffect, useState } from "react";
import { useBrowserAPI } from "./useBrowserAPI";
import { useIsSavedSearchEnabled } from "@/components/contacting/hooks/useIsSavedSearchEnabled";
import { useClassifiedId } from "@/contexts/classified/hooks";
import { useMortgage } from "./useMortgage";
export const useSendSavedSearchOptIn = () => {
    const { env: stage, brand } = useConfig();
    const [search, setSearch] = useState("");
    const { createSavedSearch } = useCreateSavedSearch({
        page: "lead",
        stage,
    });
    const classifiedId = useClassifiedId();
    const { price } = useMortgage() || {};
    const { bWindow } = useBrowserAPI();
    useEffect(() => {
        if (typeof bWindow !== "undefined") {
            const searchParam = new URL(bWindow.location.href).searchParams.get("search");
            setSearch(searchParam !== null && searchParam !== void 0 ? searchParam : "");
        }
    }, [bWindow]);
    const { savedSearchOptIn } = getFeaturesEnabled();
    const isSavedSearchTestEnabled = useIsSavedSearchEnabled();
    const isSaveSearchOptInEnabledFR = savedSearchOptIn && !!search;
    const isSaveSearchOptInEnabledDE = isSavedSearchTestEnabled && !!search;
    const handleSavedSearchOptIn = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const isFeatureEnabled = isSaveSearchOptInEnabledDE || isSaveSearchOptInEnabledFR;
        if (!isFeatureEnabled ||
            !((_a = data.newsletterOptInPreference) === null || _a === void 0 ? void 0 : _a.includes("email"))) {
            return;
        }
        // For DE brands: create saved search if newsletterOptout is true
        // For FR brands: create saved search if newsletterOptout is false
        const shouldCreateSavedSearch = isSaveSearchOptInEnabledDE
            ? data.newsletterOptout
            : !data.newsletterOptout;
        if (!shouldCreateSavedSearch) {
            return;
        }
        const email = data.email;
        const searchModel = mapQuerystringToSearchModel({
            brand,
            querystring: search,
            searchType: "classified",
        });
        if (!searchModel) {
            console.error(`No search model could be created from search: ${search}`);
            return;
        }
        const classifiedInfo = classifiedId
            ? {
                id: classifiedId,
                price,
            }
            : undefined;
        try {
            const response = yield createSavedSearch({
                searchModel,
                email,
                classifiedInfo,
            });
            if ("error" in response) {
                console.error("Error response", response.error);
            }
            return response;
        }
        catch (error) {
            console.error("Error saving search", error);
        }
    });
    return {
        handleSavedSearchOptIn,
    };
};
